export default __webpack_public_path__ + "static/media/profile.f39b42c1.png";